import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

type ConnectionStatus = 'pending' | 'mutual';

export interface ConnectionPreview {
  id: number;
  name: string | null;
  profile_image: string | null;
  profile_image_color: string | null;
  status: ConnectionStatus;
}

export interface CustomerNewConnections {
  current: number;
  total: number;
  pending: ConnectionPreview[];
  mutual: ConnectionPreview[];
  upcoming: ConnectionPreview[];
}

@Component({
  selector: 'app-customer-new-connections',
  templateUrl: './customer-new-connections.component.html',
  styleUrls: ['./customer-new-connections.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomerNewConnectionsComponent {
  @Input() newConnections: CustomerNewConnections | null = null;
  @Input() detailStatus: string | null = null;

  readonly title = 'New Connections';
  readonly defaultTotal = 32;

  get pendingConnections(): ConnectionPreview[] {
    return this.newConnections?.pending ?? [];
  }

  get mutualConnections(): ConnectionPreview[] {
    return this.newConnections?.mutual ?? [];
  }

  get upcomingConnections(): ConnectionPreview[] {
    return this.newConnections?.upcoming ?? [];
  }

  get upcomingCount(): number {
    return this.upcomingConnections.length;
  }

  get pendingCount(): number {
    return this.pendingConnections.length;
  }

  get mutualCount(): number {
    return this.mutualConnections.length;
  }

  profileUrl(connection: ConnectionPreview): string {
    if (!connection || !connection.id) {
      return '#';
    }

    const status =
      this.detailStatus && this.detailStatus.trim().length
        ? this.detailStatus
        : 'approved';

    return `/#/customer-detail/${connection.id}/${status}`;
  }

  get connectedCount(): number {
    return this.newConnections?.current ?? 0;
  }

  get totalSlots(): number {
    return this.newConnections?.total ?? this.defaultTotal;
  }

  get showDivider(): boolean {
    return (
      this.pendingConnections.length > 0 && this.mutualConnections.length > 0
    );
  }

  get hasConnections(): boolean {
    return (
      this.pendingConnections.length > 0 || this.mutualConnections.length > 0
    );
  }

  avatarSource(connection: ConnectionPreview): string {
    return (
      connection.profile_image_color ||
      connection.profile_image ||
      'assets/images/userimg.png'
    );
  }

  avatarLabel(connection: ConnectionPreview): string {
    return connection.name || 'Connection';
  }
}
